import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Outlet, useNavigate } from 'react-router';
import { useIsFeatureSupported, useUserSelfDetails } from '@steelbuy/data-access';
import { UserRole, Feature } from '@steelbuy/ts-shared';
import { SuccessErrorNotificationContextProvider, WizardStepsContextProvider } from '@steelbuy/ui-primitive';
import { BulkListingContextProvider } from '../../components/bulk-listing/bulk-listing-context/BulkListingContext';
import { BULK_LISTING_STEPS } from '../../components/bulk-listing/bulkListingUtil';
import { RoutePath } from '../../router/Routes';

export const BulkListingView = () => {
    const { data: userData } = useUserSelfDetails();
    const navigate = useNavigate();
    const methods = useForm({
        defaultValues: {
            autoRenew: true,
        },
    });
    const isListingDraftSupported = useIsFeatureSupported(Feature.LISTING_DRAFT);
    const isCreateListingSupported = userData?.roles.includes(UserRole.SELLER) || isListingDraftSupported;

    useEffect(() => {
        if (!isCreateListingSupported) {
            navigate(RoutePath.MY_LISTINGS, { replace: true });
        }
    }, []);

    if (!isCreateListingSupported) {
        return null;
    }

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(() => {})}>
                <BulkListingContextProvider>
                    <SuccessErrorNotificationContextProvider>
                        <WizardStepsContextProvider steps={BULK_LISTING_STEPS}>
                            <Outlet />
                        </WizardStepsContextProvider>
                    </SuccessErrorNotificationContextProvider>
                </BulkListingContextProvider>
            </form>
        </FormProvider>
    );
};
